import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import { sizes } from "../../../enums";
import Header from "../../core/header";
var Panel = createComponent({
  displayName: 'Panel',
  propTypes: {
    header: PropTypes.string,
    byline: PropTypes.string,
    children: PropTypes.node,
    hasBorder: PropTypes.bool,
    childSpacing: PropTypes.oneOf(sizes.ALL),
    padding: PropTypes.oneOfType([PropTypes.oneOf(sizes.ALL), PropTypes.shape({
      horizontal: PropTypes.oneOf(sizes.ALL),
      vertical: PropTypes.oneOf(sizes.ALL)
    })])
  },
  defaultProps: {
    header: null,
    byline: null,
    children: null,
    hasBorder: true,
    childSpacing: sizes.X4,
    padding: sizes.X4
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _classnames;

    /*
       no defaults for horizontal and vertical padding props, in order
       for null value to set padding to zero.
    */
    var classname = classnames('ck-panel', props.childSpacing, (_classnames = {}, _classnames["padding-" + props.padding] = _.isString(props.padding), _classnames["padding-vertical-" + props.padding.vertical] = !!props.padding.vertical, _classnames["padding-horizontal-" + props.padding.horizontal] = !!props.padding.horizontal, _classnames.bordered = props.hasBorder, _classnames.inverted = props.isInverted, _classnames));
    return /*#__PURE__*/React.createElement("div", {
      className: classname,
      style: props.style
    }, !!props.header || !!props.byline ? /*#__PURE__*/React.createElement(Header, {
      text: props.header,
      byline: props.byline
    }) : null, props.children);
  }
});
export default whitelistStyles()(Panel);
//# sourceMappingURL=panel.js.map